
import { AdminSessionView } from './admin/AdminSessionView'
import { TeacherSessionView } from './teacher/TeacherSessionView'

import { PersonaSwitcher } from '../PersonaSwitcher';

interface SessionProps {
    canEditCourse: boolean;
    session: any;
    refetchCourse: () => void;
}

const Session = ({
    canEditCourse,
    session,
    refetchCourse,
}: SessionProps ) =>
  <PersonaSwitcher
      adminView={ <AdminSessionView canEditCourse={canEditCourse} session={session} refetchCourse={refetchCourse} />}
      teacherView={ <TeacherSessionView canEditCourse={canEditCourse} session={session} refetchCourse={refetchCourse} />}
  />

export { Session }
